<template>
  <div ref="editor" style="text-align:left;height:100%;"></div>
</template>

<script>
import E from 'wangeditor'
import axios from 'axios'
export default {
  name: '',
  props: [],
  data() {
    return {
      editor: null,
      editorContent: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 初始化富文本编辑器
      this.setEditor()
    })
  },
  methods: {
    setDitable(is) {
      // 禁用启用编辑功能
      this.$nextTick(() => {
        this.editor.$textElem.attr('contenteditable', !is)
      })
    },
    clear() {
      //清空编辑器内容。
      this.$nextTick(() => {
        this.editor.txt.clear()
      })
    },
    sethtml(content) {
      //获取 新增编辑器内容
      this.$nextTick(() => {
        this.editor.txt.html(content)
      })
    },
    gethtml() {
      //新增 新增编辑器内容
      return this.editor.txt.html()
    },
    htmlappend(content) {
      //追加内容
      this.editor.txt.append(content)
    },
    setEditor() {
      //初始化
      this.editor = new E(this.$refs.editor)
      this.editor.customConfig.showLinkImg = false //关闭网络路径图片方式
      this.editor.customConfig.uploadImgServer =
        axios.defaults.baseURL + '/file/uploadRichText' // 上传图片的接口地址
      this.editor.customConfig.uploadFileName = 'file' // formdata中的name属性
      this.editor.customConfig.uploadImgHeaders = {
        Satoken: localStorage.getItem('token'), // 设置请求头
      }
      // this.editor.customConfig.debug = true // 开启debug模式
      this.editor.customConfig.uploadImgHooks = {
        // 图片上传并返回结果，但图片插入错误时触发
        fail: (xhr, editor, result) => {
          console.log(xhr, editor, result)
          if (result) {
            this.$message.success('图片插入错误,请重新上传！')
          }
        },
        success: (xhr, editor, result) => {
          // 图片上传并返回结果，图片插入成功之后触发
          console.log(xhr, editor, result, 'success')
          if (result.errno == 0) {
            this.$message.success('上传成功')
          } else {
            this.$message.success('上传失败,请重新上传！')
          }
        },
      }
      this.editor.customConfig.onchange = (html) => {
        this.editorContent = html
      }

      this.editor.create()
    },
  },
}
</script>
<style  >
.w-e-text {
  color: #fff;
}
.w-e-toolbar,.w-e-text-container{ border:#3570ff solid 1px !important;}
.w-e-toolbar{ background: #3570ff !important;}
.w-e-toolbar .w-e-menu{ padding:10px 12px 6px;}
.w-e-toolbar .w-e-menu i{ color: #fff; font-size: 20px;}
/* .w-e-text-container{
    min-height: 300px !important;
    max-height: 360px !important;
    height: 100% !important;
    overflow: auto;
} */
</style>